// import React from "react";
// import { Link as RouterLink } from "react-router-dom";
// import sylvr_logo from "../../assets/images/sylvr-logo.jpg";

// import {
//   Box,
//   Flex,
//   Button,
//   Image,
//   Link,
//   HStack,
// } from "@chakra-ui/react";

// const HomePage = () => {  
//   return (
//     <Box
//       position="fixed"
//       top="0"
//       left="0"
//       right="0"
//       bg="white"
//       boxShadow="sm"
//       zIndex="50"
//     >
//       <Flex
//         maxW="7xl"
//         mx="auto"
//         px={6}
//         py={4}
//         align="center"
//         justify="space-between"
//       >
//         {/* Left Section - Logo */}
//         <Link as={RouterLink} to="/" display="flex" alignItems="center">
//           <Image
//             src={sylvr_logo}
//             alt="Sylvr Logo"
//             h="44px"
//             objectFit="contain"
//           />
//         </Link>

//         {/* Middle Links */}
//         <HStack
//           spacing={10}
//           display={{ base: "none", md: "flex" }}
//           fontWeight="bold"
//         >
//           <Link
//             as={RouterLink}
//             to="/why-us"
//             color="gray.600"
//             _hover={{ color: "#2F5DA6" }}
//             fontSize="16px"
//           >
//             About
//           </Link>

//           <Link
//             as={RouterLink}
//             to="/how-it-works"
//             color="gray.600"
//             _hover={{ color: "#2F5DA6" }}
//             fontSize="16px"
//           >
//             How It Works
//           </Link>

//           <Link
//             as={RouterLink}
//             to="/why-us"
//             color="gray.600"
//             _hover={{ color: "#2F5DA6" }}
//             fontSize="16px"
//           >
//             Why Us
//           </Link>

//           <Link
//             as={RouterLink}
//             to="/why-us"
//             color="gray.600"
//             _hover={{ color: "#2F5DA6" }}
//             fontSize="16px"
//           >
//             Product
//           </Link>
//         </HStack>

//         {/* Right Button */}
//         <Button
//           as={RouterLink}
//           to="/insights"
//           bg="#2AA198"
//           color="white"
//           px={6}
//           py={6}
//           borderRadius="lg"
//           _hover={{ bg: "#1F7A73" }}
//         >
//           Explore Insights
//         </Button>
//       </Flex>
//     </Box>
//   );
// };

// export default HomePage;


import React, { useEffect } from "react";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import sylvr_logo from "../../assets/images/sylvr-logo.jpg";

import {
  Box,
  Flex,
  Button,
  Image,
  Link,
  HStack,
} from "@chakra-ui/react";

import {
  getSectorCategories,
  getAllSectors,
} from "../../actions/sector/sectorActions";

const HomePage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {
    categories = [],
    data: products = [],
  } = useSelector((state) => state.sectorSmmReducer || {});

  // Load categories
  useEffect(() => {
    if (!categories.length) {
      dispatch(getSectorCategories());
    }
  }, [dispatch]);

  // Load sectors
  useEffect(() => {
    if (categories.length > 0 && products.length === 0) {
      dispatch(getAllSectors(categories[0]));
    }
  }, [categories, dispatch]);

  // Extract sector id
  const sectorId = products?.[0]?.id;

  const handleExplore = () => {
    if (sectorId) {
      navigate(`/sector/${sectorId}/details`);
    }
  };

  return (
    <Box
      position="fixed"
      top="0"
      left="0"
      right="0"
      bg="white"
      boxShadow="sm"
      zIndex="50"
    >
      <Flex
        maxW="7xl"
        mx="auto"
        px={6}
        py={4}
        align="center"
        justify="space-between"
      >
        {/* Left Section - Logo */}
        <Link as={RouterLink} to="/" display="flex" alignItems="center">
          <Image
            src={sylvr_logo}
            alt="Sylvr Logo"
            h="44px"
            objectFit="contain"
          />
        </Link>

        {/* Middle Links */}
        <HStack
          spacing={10}
          display={{ base: "none", md: "flex" }}
          fontWeight="bold"
        >
          <Link
            as={RouterLink}
            to="/why-us"
            color="gray.600"
            _hover={{ color: "#2F5DA6" }}
            fontSize="16px"
          >
            About
          </Link>

          <Link
            as={RouterLink}
            to="/how-it-works"
            color="gray.600"
            _hover={{ color: "#2F5DA6" }}
            fontSize="16px"
          >
            How It Works
          </Link>

          <Link
            as={RouterLink}
            to="/why-us"
            color="gray.600"
            _hover={{ color: "#2F5DA6" }}
            fontSize="16px"
          >
            Why Us
          </Link>

          <Link
            as={RouterLink}
            to="/why-us"
            color="gray.600"
            _hover={{ color: "#2F5DA6" }}
            fontSize="16px"
          >
            Product
          </Link>
        </HStack>

        {/* Explore Insights Button */}
        <Button
          onClick={handleExplore}
          bg="#2AA198"
          color="white"
          px={6}
          py={6}
          borderRadius="lg"
          _hover={{ bg: "#1F7A73" }}
        >
          Explore Insights
        </Button>
      </Flex>
    </Box>
  );
};

export default HomePage;